import { LitElement, html, css } from 'lit'

export default class FormSection extends LitElement{

    static get styles(){return css`
        :host {
            display: block;
            position:relative;
        }
    `}

    createRenderRoot(){ return this }

    connectedCallback(){
        super.connectedCallback()

        let el = this
        let model = null
        while( el && !model ){
            el = el.parentElement
            if( el && el.model )
                model = el.model
        }

        this.model = model
    }

    render(){return html`
        <b-paper>

            <header>
                <h3>${this.title}</h3>
            </header>

            <!-- <form-handler> -->
                ${this.renderControls()}
            <!-- </form-handler> -->

        </b-paper>
    `}

    renderControls(){ return 'Render controls here'}

}

export {FormSection, html, css}